import React, { useEffect, useState } from "react";
import CustomDateRangePicker from "./CustomDataRangePicker";
import { Popover, PopoverTrigger, PopoverContent } from "./popover";
import CustomMonthPicker from "./CustomMonthPicker";

const monthNames = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const Card = ({
  style = "w-full h-full",
  title,
  showHeader = true,
  showDatePicker = false,
  showMonthPicker = false,
  singleDateMode = false,
  monthsToShow = 2,
  headerButton = null,
  headerClassName = "bg-btn-primary",
  contentPosition = "items-center justify-center",
  selectedMonth,
  onMonthChange,
  minDate,
  maxDate,
  dateRange,
  onDateRangeChange,
  children,
}) => {
  const [range, setRange] = useState({ from: null, to: null });
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isMonthPickerOpen, setIsMonthPickerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const currentRange = dateRange || { from: null, to: null };
  const displayRange = dateRange || { from: null, to: null };

  const formatMensalText = () => {
    if (
      selectedMonth &&
      typeof selectedMonth === "object" &&
      selectedMonth.from
    ) {
      const dateParts = selectedMonth.from.split("-");
      const year = dateParts[0];
      const month = dateParts[1];

      return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
    }
    return "Escolher mês";
  };

  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  return (
    <div
      className={`bg-white shadow-md rounded-xl flex flex-col ${style} overflow-y-visible`}
    >
      {showHeader && (
        <div
          className={`flex items-center justify-between px-6 py-4 ${headerClassName} relative rounded-t-xl min-h-16`}
        >
          <h2 className="text-lg text-white">{title}</h2>

          {showMonthPicker && (
            <Popover
              open={isMonthPickerOpen}
              onOpenChange={setIsMonthPickerOpen}
            >
              <PopoverTrigger asChild>
                <button className="text-sm bg-white px-3 py-1 rounded-full border border-btn-secundary shadow">
                  {formatMensalText()}
                </button>
              </PopoverTrigger>
              <PopoverContent className="inline-flex justify-center bg-white border border-btn-secundary rounded-2xl shadow-md p-3 z-50 w-auto max-w-[24rem]">
                <CustomMonthPicker
                  defaultMonth={selectedMonth}
                  minDate={minDate}
                  maxDate={maxDate}
                  onChange={(newMonth) => {
                    onMonthChange(newMonth);
                    setIsMonthPickerOpen(false);
                  }}
                  onClose={() => setIsMonthPickerOpen(false)}
                />
              </PopoverContent>
            </Popover>
          )}

          {showDatePicker && (
            <Popover
              open={isDatePickerOpen}
              onOpenChange={setIsDatePickerOpen}
            >
              <PopoverTrigger asChild>
                <button className="text-sm bg-white px-3 py-1 rounded-full border border-btn-secundary shadow">
                  {displayRange.from
                    ? singleDateMode
                      ? `${displayRange.from.slice(0, 10).replace(/-/g, "/")}`
                      : displayRange.to
                        ? `${displayRange.from.slice(0, 10).replace(/-/g, "/")} - ${displayRange.to.slice(0, 10).replace(/-/g, "/")}`
                        : `${displayRange.from.slice(0, 10).replace(/-/g, "/")}`
                    : singleDateMode
                      ? "Escolher dia"
                      : "Escolher datas"}
                </button>
              </PopoverTrigger>
              <PopoverContent className="bg-white border border-btn-secundary rounded-2xl shadow-md p-3 z-50 w-auto">
                <CustomDateRangePicker
                  from={displayRange.from}
                  to={displayRange.to}
                  minDate={minDate}
                  maxDate={maxDate}
                  monthsToShow={isMobile ? 1 : monthsToShow}
                  singleDateMode={singleDateMode}
                  onChange={(newRange) => {
                    onDateRangeChange(newRange);
                    setIsDatePickerOpen(false);
                  }}
                  onClose={() => setIsDatePickerOpen(false)}
                />
              </PopoverContent>
            </Popover>
          )}

          {headerButton && headerButton}
        </div>
      )}

      <div
        className={`flex-1 px-8 py-6 flex ${contentPosition} ${
          !showHeader ? "rounded-t-xl" : ""
        }`}
      >
        {children ? (
          children
        ) : (
          <span className="text-gray-400">Conteúdo aqui</span>
        )}
      </div>
    </div>
  );
};

export default Card;
